export default "__VITE_ASSET__Cex$lmGk__"